import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

/**
 * Interface for dialog feature card data
 */
export interface GivingInfoFeatureCard {
  /**
   * The feature title (bold)
   */
  title: string;

  /**
   * The feature description
   */
  description: string;
}

/**
 * Interface for dialog data
 */
export interface GivingInfoDialogData {
  /**
   * The main heading
   */
  heading: string;

  /**
   * The image source URL
   */
  imageSrc: string;

  /**
   * The image alt text
   * @default 'Dialog image'
   */
  imageAlt?: string;

  /**
   * About section heading
   */
  aboutHeading: string;

  /**
   * About section description
   */
  aboutDescription: string;

  /**
   * What We Do section heading
   */
  whatWeDoHeading: string;

  /**
   * What We Do section description
   */
  whatWeDoDescription: string;

  /**
   * Array of feature cards (4 items)
   */
  features: GivingInfoFeatureCard[];

  /**
   * Footer text
   */
  footerText: string;
}

@Component({
  selector: 'app-giving-info-dialog',
  standalone: false,
  templateUrl: './giving-info-dialog.component.html',
  styleUrl: './giving-info-dialog.component.scss',
})
export class GivingInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GivingInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GivingInfoDialogData,
    private router: Router
  ) {}

  onClose(): void {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // On mobile, navigate back to about page
      this.router.navigate(['/about']);
    }

    // Always close the dialog
    this.dialogRef.close();
  }
}
